import React, { useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin`;
const fmt = (n) => `₹${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

export default function CommissionAccountingPanel({ bookingId, commission, onRefresh }) {
  const ca = commission?.accounting;
  const [busy, setBusy] = useState(null);
  const [msg, setMsg] = useState(null);

  if (!commission?.module_on) {
    return (
      <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 text-xs text-gray-500" data-testid="commission-panel-off">
        Commission & TDS module is disabled in GST Settings.
      </div>
    );
  }
  if (!ca?.enabled) {
    return (
      <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 text-xs text-gray-500" data-testid="commission-panel-empty">
        No commission block on this booking.
      </div>
    );
  }

  const act = async (path, label, params = {}) => {
    setBusy(label);
    setMsg(null);
    try {
      await axios.post(`${API}/bookings/${encodeURIComponent(bookingId)}/commission/${path}`, null, {
        withCredentials: true,
        params,
      });
      setMsg({ ok: true, text: `${label} OK` });
      if (onRefresh) onRefresh();
    } catch (e) {
      setMsg({ ok: false, text: e?.response?.data?.detail || `${label} failed` });
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 space-y-3" data-testid="commission-accounting-panel">
      <p className="text-[10px] uppercase font-bold text-gray-500">Commission & TDS (194H)</p>
      {msg && (
        <p className={`text-xs px-2 py-1 rounded ${msg.ok ? 'bg-emerald-50 text-emerald-800' : 'bg-rose-50 text-rose-800'}`}>{msg.text}</p>
      )}
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2 text-xs">
        <div className="bg-gray-50 rounded p-2"><span className="text-gray-500 block">Supplier gross</span><strong>{fmt(ca.supplier_commission_gross)}</strong></div>
        <div className="bg-gray-50 rounded p-2"><span className="text-gray-500 block">Supplier TDS</span><strong>{fmt(ca.supplier_tds_amount)}</strong></div>
        <div className="bg-gray-50 rounded p-2"><span className="text-gray-500 block">Net received</span><strong>{fmt(ca.supplier_commission_net_received)}</strong></div>
        <div className="bg-sky-50 rounded p-2"><span className="text-sky-700 block">Agent gross</span><strong>{fmt(ca.agent_commission_gross)}</strong></div>
        <div className="bg-sky-50 rounded p-2"><span className="text-sky-700 block">Agent TDS</span><strong>{fmt(ca.agent_tds_amount)}</strong></div>
        <div className="bg-sky-50 rounded p-2"><span className="text-sky-700 block">Agent net payable</span><strong>{fmt(ca.agent_commission_net_payable)}</strong></div>
        <div className="bg-emerald-50 rounded p-2 col-span-2"><span className="text-emerald-700 block">ACF retained</span><strong>{fmt(ca.acf_commission_retained_gross)}</strong></div>
        <div className="bg-gray-50 rounded p-2"><span className="text-gray-500 block">Status</span><strong className="uppercase">{ca.status}</strong></div>
      </div>
      <div className="flex flex-wrap gap-2">
        {commission.can_settle_supplier && (
          <button type="button" disabled={!!busy} onClick={() => act('settle-supplier', 'Settle supplier')} className="px-2 py-1 text-xs font-semibold bg-[#1B375B] text-white rounded">
            Post supplier receipt
          </button>
        )}
        {commission.can_credit_agent && (
          <>
            <button type="button" disabled={!!busy} onClick={() => act('credit-agent', 'Accrued to books', { credit_wallet: false })} className="px-2 py-1 text-xs font-semibold border border-[#1B375B] text-[#1B375B] rounded">
              Accrue to books
            </button>
            <button type="button" disabled={!!busy} onClick={() => act('credit-agent', 'Credited to agent', { credit_wallet: true })} className="px-2 py-1 text-xs font-semibold bg-emerald-700 text-white rounded">
              Credit to agent
            </button>
          </>
        )}
        {(ca.agent_payout_status === 'credited' || ca.agent_wallet_credit_status === 'credited') && (
          <span className="text-xs text-emerald-700 font-semibold px-2 py-1 bg-emerald-50 rounded">
            Credited via {ca.agent_payout_method || 'wallet'}
          </span>
        )}
      </div>
    </div>
  );
}
